'use client';

import { Close as CloseIcon } from '@mui/icons-material';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import classes from './EmergencyAlertDialog.module.scss';
import Button from '../Buttons/Button';
interface EmergencyAlertDialogProps {
  open: boolean;
  onClose: () => void;
}
const EmergencyAlertDialog = ({
  open,
  onClose
}: EmergencyAlertDialogProps) => {
  return <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth className={classes['emergency-dialog']} aria-labelledby="emergency-alert-title" aria-describedby="emergency-alert-description" data-sentry-element="Dialog" data-sentry-component="EmergencyAlertDialog" data-sentry-source-file="EmergencyAlertDialog.tsx">
			<DialogTitle className={classes['dialog-title']} data-sentry-element="DialogTitle" data-sentry-source-file="EmergencyAlertDialog.tsx">
				<Typography component="h2" id="emergency-alert-title" data-sentry-element="Typography" data-sentry-source-file="EmergencyAlertDialog.tsx">
					Emergency Alert
				</Typography>
				<IconButton aria-label="Close emergency alert" onClick={onClose} className={classes['close-button']} data-sentry-element="IconButton" data-sentry-source-file="EmergencyAlertDialog.tsx">
					<CloseIcon data-sentry-element="CloseIcon" data-sentry-source-file="EmergencyAlertDialog.tsx" />
				</IconButton>
			</DialogTitle>
			<DialogContent className={classes['dialog-content']} data-sentry-element="DialogContent" data-sentry-source-file="EmergencyAlertDialog.tsx">
				<Typography id="emergency-alert-description" className={classes['alert-message']} data-sentry-element="Typography" data-sentry-source-file="EmergencyAlertDialog.tsx">
					If you are experiencing any life-threatening symptoms including chest pain, abdominal pain, or
					difficulty breathing — or if you need immediate attention, please proceed to the Emergency Room or
					dial 911.
				</Typography>
				<Box className={classes['button-container']} data-sentry-element="Box" data-sentry-source-file="EmergencyAlertDialog.tsx">
					<Button onClick={onClose} variant="primary" className={classes['understand-button']} aria-label="I understand the emergency guidance" data-sentry-element="Button" data-sentry-source-file="EmergencyAlertDialog.tsx">
						I Understand
					</Button>
				</Box>
			</DialogContent>
		</Dialog>;
};
export default EmergencyAlertDialog;